import React from "react";
import {Button} from "@reside/ui";

import {downloadBlankPdf} from "../../../../../services/AdmissionsService";
import {useFacilitySettingsParams} from "../../../hooks/useFacilitySettingsParams";
import {useDownloadManager} from "../../../../../hooks/useDownloadManager";

export const DownloadButton = ({
  facilityTemplate,
  label,
}: {
  facilityTemplate: string;
  label: string;
}): JSX.Element => {
  const {facilityId} = useFacilitySettingsParams();
  const {start} = useDownloadManager();

  return (
    <Button
      color="primary"
      outline
      onClick={() => {
        start(label, () =>
          downloadBlankPdf(facilityId, facilityTemplate, "full"),
        );
      }}
    >
      {label}
    </Button>
  );
};
